import { SET_LOCALE } from './actions';

export default {
    [SET_LOCALE]: (state, payload) => {
        state.locale = payload;
    },
};
